import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Calendar } from 'primereact/calendar';
import dayjs from 'dayjs';

const BaseCalendar = ({
    className,
    value,
    setDate,
    selectionMode = 'single',
    minDate,
    maxDate,
    loadData = {},
    disableDates = false
}) => {
    const customDateTemplate = (date) => {
        const dayDate = dayjs(date.year + '-' + (date.month + 1) + '-' + date.day, 'YYYY-M-D');

        const dayMeetings = loadData[dayDate.format('YYYY-MM-DD')] || 0;

        let extraClassName = '';
        if (dayMeetings >= 1 && dayMeetings <= 3) {
            extraClassName += 'bg-theme1-success text-theme1-white';
        } else if (dayMeetings >= 4 && dayMeetings <= 5) {
            extraClassName += 'bg-theme1-warning text-theme1-white ';
        } else if (dayMeetings > 5) {
            extraClassName += 'bg-theme1-primary text-theme1-white';
        }

        return (
            <div className={twMerge('w-full h-full flex items-center justify-center text-theme1-dark', extraClassName)}>
                {date.day}
            </div>
        );
    };

    const handleChange = (e) => {
        if (!disableDates) {
            setDate(e.value);
        }
    };

    return (
        <div
            className={twMerge('relative w-full', disableDates && 'pointer-events-none opacity-30')}
            onClick={(e) => disableDates && e.preventDefault()}
        >
            <Calendar
                value={value}
                className={twMerge('w-full z-[999]', className)}
                inline
                selectionMode={selectionMode}
                dateTemplate={customDateTemplate}
                minDate={minDate}
                maxDate={maxDate}
                prevIcon={
                    <svg
                        width='24'
                        height='24'
                        viewBox='0 0 32 32'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='stroke-theme1-text1'
                    >
                        <path
                            d='M20 25.3333L10.6667 16L20 6.66667'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                }
                nextIcon={
                    <svg
                        width='24'
                        height='24'
                        viewBox='0 0 32 32'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='stroke-theme1-text1'
                    >
                        <path
                            d='M12 6.66666L21.3333 16L12 25.3333'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                        />
                    </svg>
                }
                onChange={handleChange}
            />
        </div>
    );
};

export default BaseCalendar;
